import { UI_Container } from 'ui/components/4-habitats/Container/Container';
import classNames from 'classnames';
import { UI_TopLevelGrid } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGrid';
import { UI_TopLevelGridCell } from 'ui/components/4-habitats/TopLevelGrid/TopLevelGridCell';
import { UI_Kicker, UI_KickerProps } from 'ui/components/1-atoms/Kicker/Kicker';
import { UI_TileCard, UI_TileCardProps } from 'ui/components/2-molecules/Card/TileCard/TileCard';
import ColorOptions from 'helpers/types';
import styles from './TileList.module.scss';

export interface UI_TileListProps {
	kicker?: UI_KickerProps;
	items: UI_TileCardProps[];
	bgColor?: ColorOptions;
}

export const UI_TileList: React.FC<UI_TileListProps> = ({ items, kicker, bgColor = 'white' }) => {
	const kickerExists = kicker && (kicker.firstWord || kicker.secondWord);
	return (
		<div className={classNames(styles.TileList, styles[`u-color___${bgColor}`], { [styles[`TileList___withKicker`]]: kicker })}>
			<UI_Container width="Standard">
				<UI_TopLevelGrid container wrap>
					{kickerExists && (
						<UI_TopLevelGridCell desktopWidth="7col" mobileWidth="100">
							<UI_Kicker {...kicker} className={styles.TileList_kicker} />
						</UI_TopLevelGridCell>
					)}
					<UI_TopLevelGridCell desktopWidth="15col" desktopOffset={kickerExists ? null : '2col'} offsetDirection="right" mobileWidth="100">
						{items.map((item, index) => (
							<UI_TileCard noPaddingTop={kickerExists && index === 0} {...item} key={index} />
						))}
					</UI_TopLevelGridCell>
				</UI_TopLevelGrid>
			</UI_Container>
		</div>
	);
};
